import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
//Components
import { Text } from "../../atoms/index";
import { PlusButton } from "../../molecules/index";
import theme from "../../../styles/theme.semantic";

const CandidatureCard = ({
  children,
  className,
  buttonBgColor,
  titleColor,
  title
}) => {
  return (
    <div className={className} tabIndex={0}>
      <div className="content-container">
        <PlusButton
          backgroundColor={buttonBgColor}
          size="40px"
          zIndex="1"
          top="-20px"
          right="-20px"
          aria-hidden="true"
          tabIndex={-1}
        >
          <Text
            fontSize="40px"
            fontWeight="100"
            color="#ffffff"
            text="+"
            lineHeight="0"
          />
        </PlusButton>
        <Text as="h3" text={title} size="mediumSmall" color={titleColor} />
        {children}
      </div>
    </div>
  );
};

CandidatureCard.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  buttonBgColor: PropTypes.string,
  titleColor: PropTypes.string,
  title: PropTypes.string
};

CandidatureCard.defaultProps = {
  buttonBgColor: theme.components.candidatureCard.buttonBackgroundColor,
  titleColor: theme.components.candidatureCard.titleColor,
  title: "Título"
};

const CandidatureCardWithStyles = styled(CandidatureCard)`
  height: inherit;
  position: relative;
  background-color: ${props =>
    props.theme.components.candidatureCard.cardBackgroundColor};
  word-break: break-word;

  .content-container {
    padding: 20px;
  }
`;

export default CandidatureCardWithStyles;
